
import { mapGetters } from 'vuex'
import PlpFilters from './plp-filters'
import PlpResults from './plp-results'
import Empty from './empty'

export default {
  components: {
    PlpFilters,
    PlpResults,
    Empty,
  },
  computed: {
    ...mapGetters({
      vxSearchResults: 'search/getSearchResults',
      vxIsSearching: 'search/getIsSearching',
    }),
  },
  methods: {
    sendGtmData() {
      try {
        this.$gtm.push({
          ecommerce: undefined,
          product: undefined,
          search: undefined,
        })
        if (this.pageName === 'search')
          this.$gtmEvents.DLSearchPage(this.products)
      } catch (e) {
        this.$sentryException(e, {
          source: 'GTM page internal search',
          level: 'warning',
          extra: 'GTM page internal search failed',
        })
      }
    },
    addGAImpression() {
      try {
        this.$gtmEvents.UAProductsImpression(this.products, {
          page: this.$route.fullPath,
        })
      } catch (error) {
        this.$sentryException(error, {
          source: 'store',
          level: 'warning',
          extra: 'Recently viewed - failed to log gtm event',
        })
      }
    },
  },
}
